import { GeofenceType, geofenceToWkt, wktToGeofence, WorkshopGeometry } from "../models/workshop.model";
import { WorkshopDetailsResponse, WorkshopLocationResponse } from "../models/workshop-response.model";
import { WorkshopDetailsRequest } from "../models/workshop-request.model";

export function toWorkshopApiPayload(workshop: WorkshopDetailsRequest): any {
  let geometry: WorkshopGeometry | null = null;

  if (workshop.geofence) {
    geometry = geofenceToWkt(workshop.geofence);
  }

  return {
    id: workshop.id,
    name: workshop.name,
    location: workshop.location,
    workshopType: workshop.type,
    accountId: workshop.accountId,
    accountName: workshop.account,
    email: workshop.email,
    phoneNumber: workshop.phoneNumber,
    labourRate: workshop.labourRate,
    labourRateCurrencyId: workshop.labourRateCurrencyId,
    geometry
  };
}

export function workshopDetailsFromApiResponse(response: any): WorkshopDetailsResponse {
  let geofence = null;

  if (response.data.geometry?.wkt) {
    geofence = wktToGeofence(
      response.data.geometry.wkt,
      response.data.geometry.geometryType as GeofenceType,
      response.data.geometry.radiusMeters
    );
  }

  return {
    id: response.data.id,
    name: response.data.name,
    location: response.data.location,
    type: response.data.workshopType,
    accountId: response.data.accountId,
    account: response.data.accountName ?? '',
    email: response.data.email,
    phoneNumber: response.data.phoneNumber,
    labourRate: response.data.labourRate ?? null,
    labourRateCurrencyId: response.data.labourRateCurrencyId ?? null,
    labourRateCurrencyCode: response.data.labourRateCurrencyCode ?? null,
    latitude: geofence?.center?.lat ?? 0,
    longitude: geofence?.center?.lng ?? 0,
    geofence
  };
}

export function workshopLocationFromApiResponse(response: any): WorkshopLocationResponse[] {
  return response.data.map((item: any) => {
    const geofence =
      item.geometry?.wkt
        ? wktToGeofence(
            item.geometry.wkt,
            item.geometry.geometryType as GeofenceType,
            item.geometry.radiusMeters
          )
        : null;

    return {
      id: item.id,
      name: item.name,
      location: item.location,
      email: item.email,
      phoneNumber: item.phoneNumber,
      workshopType: item.workshopType,
      latitude: geofence?.center?.lat ?? 0,
      longitude: geofence?.center?.lng ?? 0,
      geofence
    };
  });
}